const path = require("path");
const fs = require("fs");

module.exports = function findNodeModules(baseDir) {
  let currentDir = baseDir;
  while (currentDir !== path.resolve(currentDir, "..")) {
    // Stop when reaching the root
    const candidatePath = path.join(currentDir, "node_modules");
    if (fs.existsSync(candidatePath)) {
      return candidatePath;
    }
    currentDir = path.resolve(currentDir, "..");
  }
  throw new Error("Unable to find node_modules directory.");
};
